import React from 'react';
import AppRoutes from './routes';
import 'antd/dist/antd.css';
import "./styles/_main.scss";
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './shared/components/ScrollToTop';
import ReactGA from 'react-ga4';

const App = () => {
  ReactGA.initialize('G-DD989C7N3F');
  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}

export default App;
